import * as api from '../../../../lib/api.js';
import { DownloadButton } from '../../../../components/DownloadButton';
import { usePdfContext } from './pdf-context.jsx';
import { useContext } from '../../context.jsx';
import { useGrowers } from '../../../../hooks/use-growers.js';

export function PdfButton() {
  const { getSelectedPrescriptionIds, arePrescriptionsSelected } = useContext();
  const { filters, setFilters, isFiltering, setFiltering } = usePdfContext();
  const { selectedId: growerId } = useGrowers();

  const onDownload =
    !isFiltering && filters?.length
      ? () => api.downloadLpkPdfs(growerId, getSelectedPrescriptionIds(filters))
      : null;

  function onClick() {
    setFilters([]);
    setFiltering(true);
  }

  function onDownloaded() {
    setFilters([]);
  }

  return (
    <DownloadButton
      disabled={!arePrescriptionsSelected}
      preDownload={onClick}
      autoDownload={onDownload}
      postDownload={onDownloaded}
    >
      Print to PDF
    </DownloadButton>
  );
}
